import { render, staticRenderFns } from "./RelateScheduleSpots.vue?vue&type=template&id=6f01272e&"
import script from "./RelateScheduleSpots.vue?vue&type=script&lang=js&"
export * from "./RelateScheduleSpots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports